import { useEffect } from 'react';

const ProductSEOMetaTags = ({ produto, brand, loja }) => {
  useEffect(() => {
    if (!produto) return;

    const url = `https://${brand}.grub.digital/produto/${produto.id}`;
    const imageUrl = produto.imagem 
      ? `https://grubupload.s3.amazonaws.com/${typeof produto.imagem === 'string' ? produto.imagem : produto.imagem.imagem}` 
      : 'https://grub.digital/logo.png';
    
    const preco = produto.em_promocao && produto.promocao_info?.valor_promocional
      ? produto.promocao_info.valor_promocional
      : produto.valor;
    
    const description = produto.descricao || `${produto.nome} - Peça agora!`;
    const lojaName = loja?.nome || 'Restaurante';
    const title = `${produto.nome} - ${lojaName} | GRUB Digital`;

    // Update document title
    document.title = title;

    // Helper function
    const updateMetaTag = (selector, attribute, content) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        if (selector.includes('property')) {
          element.setAttribute('property', selector.replace('meta[property="', '').replace('"]', ''));
        } else {
          element.setAttribute('name', selector.replace('meta[name="', '').replace('"]', ''));
        }
        document.head.appendChild(element);
      }
      element.setAttribute(attribute, content);
    };

    // SEO Meta Tags
    updateMetaTag('meta[name="description"]', 'content', description);
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    // Open Graph
    updateMetaTag('meta[property="og:url"]', 'content', url);
    updateMetaTag('meta[property="og:title"]', 'content', title);
    updateMetaTag('meta[property="og:description"]', 'content', description);
    updateMetaTag('meta[property="og:image"]', 'content', imageUrl);
    updateMetaTag('meta[property="og:type"]', 'content', 'product');

    // Twitter Card
    updateMetaTag('meta[name="twitter:url"]', 'content', url);
    updateMetaTag('meta[name="twitter:title"]', 'content', title);
    updateMetaTag('meta[name="twitter:description"]', 'content', description);
    updateMetaTag('meta[name="twitter:image"]', 'content', imageUrl);

    // Product Structured Data
    let scriptTag = document.querySelector('script[type="application/ld+json"]');
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.setAttribute('type', 'application/ld+json');
      document.head.appendChild(scriptTag);
    }

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": produto.nome,
      "description": description,
      "image": imageUrl,
      "url": url,
      "offers": {
        "@type": "Offer",
        "price": preco,
        "priceCurrency": "BRL",
        "availability": "https://schema.org/InStock"
      }
    };

    scriptTag.textContent = JSON.stringify(structuredData);

  }, [produto, brand, loja]);

  return null;
};

export default ProductSEOMetaTags;
